import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { LoaderType } from '@fcom/common';
import { Location } from '@fcom/core-api';
import { isObject, unsubscribe } from '@fcom/core/utils';

import { isStringWithValue } from '../../utils/timetable.utils';
@Component({
  selector: 'fin-timetable-location-search',
  templateUrl: './location-search.component.html',
  styleUrls: ['./location-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationSearchComponent implements OnInit, OnDestroy {
  @ViewChild(MatAutocompleteTrigger, { read: MatAutocompleteTrigger }) inputAutoComplete: MatAutocompleteTrigger;

  public readonly LoaderType = LoaderType;
  public readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  options$: Observable<Location[]>;

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  controlName: string;

  @Input()
  inputLabel: string;

  @Input()
  panelOpenInputLabel: string;

  @Input()
  initialValue$: Observable<Location>;

  @Output()
  selectionDone: EventEmitter<boolean> = new EventEmitter();

  inputHasValue$: Observable<boolean>;

  panelOpen = false;

  private subscriptions: Subscription = new Subscription();

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.inputHasValue$ = this.ctrlField.valueChanges.pipe(
      distinctUntilChanged(),
      map((val) => isStringWithValue(val) || isObject(val))
    );

    this.subscriptions.add(
      this.initialValue$.subscribe((location) => {
        this.ctrlField.setValue(location);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }

  setLocation(location: Location): void {
    this.ctrlField.setValue(location);
    this.selectionDone.emit(true);
  }

  displayLocation(location?: Location): string | undefined {
    return location ? `${location.title} (${location.locationCode})` : undefined;
  }

  dropdownClick(event: MouseEvent, deleteValue: boolean): void {
    event.stopPropagation();

    if (deleteValue) {
      this.ctrlField.setValue('');
      this.inputAutoComplete.closePanel();

      return;
    }

    this.renderer.selectRootElement(`#${this.controlName}`).focus();
  }

  locationSelectionEvent(): void {
    this.selectionDone.emit(true);
  }

  get ctrlField(): AbstractControl {
    return this.parentForm.get(this.controlName);
  }
}
